export const routes = (prefix = `suppliers-dashboard`) => [
    {
        path: `/${prefix}/supplier-statement-report`,
        name: `${prefix}.supplier-statement-report.index`,
        component: () => import('./supplier-statements/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.supplier-reports.index`,
                PageDescription: "Supplier Module: Supplier reports",
            },
        },
    },
    {
        path: `/${prefix}/supplier-statement-report/print`,
        name: `${prefix}.supplier-statement-report.print`,
        component: () => import('./supplier-statements/Print.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.supplier-reports.index`,
                PageDescription: "Supplier Module: Supplier reports",
            },
            print: true,
        },
    },
];
